import { Section, SectionImage } from 'services/api/vehicle-sections/types';
import { useLevel1SectionData } from './useLevel1Section';
import { useDashImages } from './useDashImages';

const DASH_DISPLAY_KEYS = [
  'check_engine_light',
  'abs_light',
  'air_bag_light',
  'any_other_lights_on',
] as const;

export const useDashSection = (): { section: Section | undefined; images: SectionImage[] } => {
  const { subSections } = useLevel1SectionData('interior_questions');
  const images = useDashImages();

  const subsections: Record<string, Section> = {};
  DASH_DISPLAY_KEYS.forEach(key => {
    const sub = subSections[key];
    if (sub?.grade) subsections[key] = sub as Section;
  });

  if (Object.keys(subsections).length === 0 && images.length === 0) {
    return { section: undefined, images };
  }

  const section: Section = {
    id: -1,
    name: 'dash',
    label: 'Dash',
    notes: null,
    grade: null,
    images: [],
    checkboxes: [],
    audio_url: null,
    buyer_order: null,
    order: null,
    subsections,
  };

  return { section, images };
};
